export default [
  {
    code: "41633099",
    format: "C4",
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.pocket",
    gsm: 120,
    boxSize: 250,
    sealing: "envelopesProperties.sealing.peelSeal",
  },
  {
    code: "41733099",
    format: "B4",
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.pocket",
    gsm: 125,
    boxSize: 250,
    sealing: "envelopesProperties.sealing.peelSeal",
  },
  {
    code: "41833070",
    format: "E4",
    color: "envelopesProperties.color.brown",
    type: "envelopesProperties.type.pocket",
    gsm: 150,
    boxSize: 250,
    sealing: "envelopesProperties.sealing.peelSeal",
  },
]
